/* eslint-disable @typescript-eslint/no-throw-literal */
/* Below is just an example function which can be called
from any of the app container pages. */
import axios from "axios";
import localeTexts from "../common/locale/en-us";

const errorResponse = ({ status, data }: any) => {
  switch (status) {
    case 401:
    case 500:
      return { error: true, data: localeTexts.Warnings.invalidCredentials };

    case 429:
      return { error: true, data };

    default:
      return { error: true, data: localeTexts.Warnings.somethingWentWrong };
  }
};

const getForm = async (obj: any) => {
  try {
    const response = await axios(
      `${process.env.REACT_APP_API_URL}?query=form`,
      {
        method: "POST",
        headers: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          "Access-Control-Allow-Origin": "*",
          // eslint-disable-next-line @typescript-eslint/naming-convention
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        data: obj,
      }
    );
    return { error: false, data: response?.data };
  } catch (err: any) {
    console.error(err);
    return errorResponse(err?.response);
  }
};

const getFormById = async (id: any) => {
  try {
    const response = await axios(
      `${process.env.REACT_APP_API_URL}?query=form`,
      {
        method: "POST",
        headers: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          "Access-Control-Allow-Origin": "*",
          // eslint-disable-next-line @typescript-eslint/naming-convention
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        data: {
          task: "formById",
          id,
        },
      }
    );
    return { error: false, data: response?.data };
  } catch (err: any) {
    console.error(err);
    return errorResponse(err?.response);
  }
};

const getBaseUrl = async () => {
  try {
    const response = await axios(
      `${process.env.REACT_APP_API_URL}?query=form`,
      {
        method: "POST",
        headers: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          "Access-Control-Allow-Origin": "*",
          // eslint-disable-next-line @typescript-eslint/naming-convention
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        data: { task: "baseUrl" },
      }
    );
    return { error: false, data: response?.data };
  } catch (err: any) {
    console.error(err);
    return errorResponse(err?.response);
  }
};

const validateCreds = async (baseUrl: any, apiKey: any) => {
  try {
    const response = await axios(
      `${process.env.REACT_APP_API_URL}?query=form`,
      {
        method: "POST",
        headers: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          "Access-Control-Allow-Origin": "*",
          // eslint-disable-next-line @typescript-eslint/naming-convention
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        data: { task: "validateCreds", baseUrl, apiKey },
      }
    );

    return { error: false, data: response };
  } catch (err: any) {
    console.error(err);
    return errorResponse(err?.response);
  }
};
const services = {
  getForm,
  getBaseUrl,
  validateCreds,
  getFormById,
};

export default services;
